// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__O7_MT","title":"ClientInsurance_title__3oaeR","itemText":"ClientInsurance_itemText__LSDj8"};